import { MenuItem, TextField } from "@mui/material"
import React from "react"
import { FilterProps } from "react-table"
import { sortArray } from "../../../helpers/utils/arrayUtils"

//This control should not be used for Server Side Filtering. The list is pulled from memory. 
export function SelectColumnFilter<T extends Record<string, unknown>>({
    column: { filterValue, render, setCustomFilter, preFilteredRows, id, filterDisplayProperty, filterOptions }}: FilterProps<T>) 
{

    const options = React.useMemo(() => {
      const options = new Array<any>();

      if(filterOptions) {
        options.push(...filterOptions);
      }
      else {

        preFilteredRows.forEach((row) => {

          let option: any | undefined = undefined;

          var entry = row.values[id];

          if(Array.isArray(entry)) {

            entry.forEach((item) => {
              option = {name: item.name, value: item?.value ?? item.name};
              if(!options.some(x => x.name === option?.name && x.value === option.value) && option.value != '') {
                options.push(option);
              }
            });
          }
          else {

            let displayName = row.values[id];

            if(filterDisplayProperty) {
              displayName = row.original[filterDisplayProperty];
            }
            else if(typeof row.values[id] === "boolean") {
              displayName = row.values[id] === true ? "Yes" : "No"
            }

            option = {name: displayName, value: row.values[id]};

            if(!options.some(x => x.name === option?.name && x.value === option.value) && option.value !== '') {
              options.push(option);
            }
          }
        });
      }

      const orderedArray = sortArray(options);

      return [...orderedArray];

    }, [id, preFilteredRows])


    return (
      <TextField
        select
        label={render('Header')}
        value={options.find(x => x.value === filterValue) ?? ''}
        onChange={(e) => {

          var sanitizedValue: any = e.target.value;
          setCustomFilter(sanitizedValue);
          
        }}
        variant='standard'
      >
        {filterValue !== undefined && filterValue !== '' && (<MenuItem value={''}>(Clear)</MenuItem>)}
        {options.map((option, i) => (
          <MenuItem key={i} value={option}>
            { option.name }
          </MenuItem>
        ))}
      </TextField>
    );

  }